function attachApprovalHandlers(tableID, type) {

    if (typeof type === "undefined") type = 'adminApproval';

    document.getElementById(tableID).onclick = function (event) {
        let target = event.target;

        // For tags with icons
        if (target.tagName !== 'A' && target.parentElement.tagName === 'A') target = target.parentElement;

        if (target.tagName === 'A' && target.classList.contains('approval')) {
            if (target.classList.contains('approval-approve')) {

                if (type === 'complianceApproval') {

                    bootbox.confirm({
                        message: "Are you sure you'd like to approve compliance for <strong>" + target.parentElement.dataset.brandName + "</strong>?",
                        buttons: {
                            confirm: {
                                label: 'Yes, approve',
                                className: 'btn-success'
                            },
                            cancel: {
                                label: 'No, cancel',
                                className: ''
                            }
                        },
                        callback: function (result) {
                            if (result) {

                                axios
                                    .put(target.dataset.url)
                                    .then(function (response) {
                                        if (typeof response.data.redirectionUrl !== "undefined") {
                                            window.location.href = response.data.redirectionUrl;
                                        } else {
                                            window.location.reload();
                                        }
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                    });

                            }
                        }
                    });

                } else {

                    bootbox.confirm({
                        message: "Are you sure you'd like to approve <strong>" + target.parentElement.dataset.brandName + "</strong>?",
                        buttons: {
                            confirm: {
                                label: 'Yes, approve',
                                className: 'btn-success'
                            },
                            cancel: {
                                label: 'No, cancel',
                                className: ''
                            }
                        },
                        callback: function (result) {
                            if (result) {

                                axios
                                    .put(target.dataset.url)
                                    .then(function (response) {
                                        if (typeof response.data.redirectionUrl !== "undefined") {
                                            window.location.href = response.data.redirectionUrl;
                                        } else {
                                            window.location.reload();
                                        }
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                    });

                            }
                        }
                    });

                }

            } else if (target.classList.contains('approval-feedback')) {

                if (type === 'retailerApproval' || type === 'storeApproval') {

                    bootbox.prompt({
                        title: "Request more information from <strong>" + target.parentElement.dataset.brandName + "</strong>",
                        message: "Please provide your feedback / additional requirements below:",
                        buttons: {
                            confirm: {
                                label: 'Request more information',
                                className: 'btn-warning'
                            },
                            cancel: {
                                label: 'Cancel',
                                className: ''
                            }
                        },
                        inputType: 'textarea',
                        required: true,
                        callback: function (result) {
                            if (result !== null) {

                                axios
                                    .put(target.dataset.url, {
                                        feedback: result
                                    })
                                    .then(function (response) {
                                        if (typeof response.data.redirectionUrl !== "undefined") {
                                            window.location.href = response.data.redirectionUrl;
                                        } else {
                                            window.location.reload();
                                        }
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                    });

                            }
                        }
                    });

                } else {

                    bootbox.prompt({
                        title: "Provide Feedback for <strong>" + target.parentElement.dataset.brandName + "</strong>",
                        buttons: {
                            confirm: {
                                label: 'Send Feedback',
                                className: 'btn-warning'
                            },
                            cancel: {
                                label: 'Cancel',
                                className: ''
                            }
                        },
                        inputType: 'textarea',
                        required: true,
                        callback: function (result) {
                            if (result !== null) {

                                axios
                                    .put(target.dataset.url, {
                                        feedback: result
                                    })
                                    .then(function (response) {
                                        window.location.reload();
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                    });

                            }
                        }
                    });

                }

            } else if (target.classList.contains('approval-reject')) {

                if (type === 'retailerApproval') {

                    bootbox.prompt({
                        title: "Are you sure you'd like to reject <strong>" + target.parentElement.dataset.brandName + "</strong>?",
                        message: "Please select a reason from below:",
                        buttons: {
                            confirm: {
                                label: 'Yes, reject',
                                className: 'btn-danger'
                            },
                            cancel: {
                                label: 'No, cancel',
                                className: ''
                            }
                        },
                        inputType: 'radio',
                        inputOptions: [
                            {
                                text: 'Don\'t like the style',
                                value: 'Don\'t like the style',
                            },
                            {
                                text: 'Price point not suitable',
                                value: 'Price point not suitable',
                            },
                            {
                                text: 'Too similar to core range',
                                value: 'Too similar to core range',
                            },
                            {
                                text: 'Product category not suitable for pop ups',
                                value: 'Product category not suitable for pop ups',
                            }
                        ],
                        required: true,
                        callback: function (result) {
                            if (result !== null) {

                                axios
                                    .put(target.dataset.url, {
                                        reason: result
                                    })
                                    .then(function (response) {
                                        if (typeof response.data.redirectionUrl !== "undefined") {
                                            window.location.href = response.data.redirectionUrl;
                                        } else {
                                            window.location.reload();
                                        }
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                    });

                            }
                        }
                    });

                } else if (type === 'storeApproval') {

                    bootbox.prompt({
                        title: "Are you sure you'd like to reject <strong>" + target.parentElement.dataset.brandName + "</strong>?",
                        message: "Please select a reason from below:",
                        buttons: {
                            confirm: {
                                label: 'Yes, reject',
                                className: 'btn-danger'
                            },
                            cancel: {
                                label: 'No, cancel',
                                className: ''
                            }
                        },
                        inputType: 'radio',
                        inputOptions: [
                            {
                                text: 'Not right for demographic',
                                value: 'Not right for demographic',
                            },
                            {
                                text: 'Not in line with store marketing',
                                value: 'Not in line with store marketing',
                            },
                            {
                                text: 'Not local to the store',
                                value: 'Not local to the store',
                            },
                            {
                                text: 'Product not suitable',
                                value: 'Product not suitable',
                            }
                        ],
                        required: true,
                        callback: function (result) {
                            if (result !== null) {

                                axios
                                    .put(target.dataset.url, {
                                        reason: result
                                    })
                                    .then(function (response) {
                                        if (typeof response.data.redirectionUrl !== "undefined") {
                                            window.location.href = response.data.redirectionUrl;
                                        } else {
                                            window.location.reload();
                                        }
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                    });

                            }
                        }
                    });

                } else { // Admin Approval

                    bootbox.prompt({
                        title: "Are you sure you'd like to reject <strong>" + target.parentElement.dataset.brandName + "</strong>?",
                        buttons: {
                            confirm: {
                                label: 'Yes, reject',
                                className: 'btn-danger'
                            },
                            cancel: {
                                label: 'No, cancel',
                                className: ''
                            }
                        },
                        inputType: 'radio',
                        inputOptions: [
                            {
                                text: 'Price point not suitable',
                                value: 'Price point not suitable',
                            },
                            {
                                text: 'Product not suitable',
                                value: 'Product not suitable',
                            },
                            {
                                text: 'Too similar to core range',
                                value: 'Too similar to core range',
                            },
                            {
                                text: 'Problem with application',
                                value: 'Problem with application',
                            }
                        ],
                        required: true,
                        callback: function (result) {
                            if (result !== null) {

                                axios
                                    .put(target.dataset.url, {
                                        reason: result
                                    })
                                    .then(function (response) {
                                        window.location.reload();
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                    });

                            }
                        }
                    });

                }

            } else if (target.classList.contains('approval-send')) {

                bootbox.prompt({
                    title: "Are you sure you'd like to send <strong>" + target.parentElement.dataset.brandName + "</strong> for approval with <strong>" + target.parentElement.dataset.retailerName + "</strong>?",
                    buttons: {
                        confirm: {
                            label: 'Yes, send',
                            className: 'btn-success'
                        },
                        cancel: {
                            label: 'No, cancel',
                            className: ''
                        }
                    },
                    inputType: 'textarea',
                    required: false,
                    callback: function (result) {
                        if (result !== null) {

                            axios
                                .post(target.dataset.url, {
                                    retailerId: target.dataset.retailerId,
                                    comments: result
                                })
                                .then(function (response) {
                                    window.location.reload();
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });

                        }
                    }
                });

            } else if (target.classList.contains('store-approval-send')) {

                bootbox.prompt({
                    title: "Are you sure you'd like to send <strong>" + target.parentElement.dataset.brandName + "</strong> for approval with <strong>" + target.parentElement.dataset.storeName + "</strong>?",
                    buttons: {
                        confirm: {
                            label: 'Yes, send',
                            className: 'btn-success'
                        },
                        cancel: {
                            label: 'No, cancel',
                            className: ''
                        }
                    },
                    inputType: 'textarea',
                    required: false,
                    callback: function (result) {
                        if (result !== null) {

                            axios
                                .post(target.dataset.url, {
                                    storeId: target.dataset.storeId,
                                    comments: result
                                })
                                .then(function (response) {
                                    window.location.reload();
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });

                        }
                    }
                });

            } else if (target.classList.contains('approval-reset')) {

                bootbox.confirm({
                    message: "Are you sure you'd like to reset <strong>" + target.parentElement.dataset.brandName + "'s</strong> approval?",
                    buttons: {
                        confirm: {
                            label: 'Yes, reset',
                            className: 'btn-success'
                        },
                        cancel: {
                            label: 'No, cancel',
                            className: ''
                        }
                    },
                    callback: function (result) {
                        if (result) {

                            axios
                                .post(target.dataset.url)
                                .then(function (response) {
                                    window.location.reload();
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });

                        }
                    }
                });

            } else if (target.classList.contains('store-approval-reset')) {

                bootbox.prompt({
                    title: "Are you sure you'd like to reset <strong>" + target.parentElement.dataset.brandName + "'s</strong> approval with <strong>" + target.parentElement.dataset.storeName + "</strong>?",
                    buttons: {
                        confirm: {
                            label: 'Yes, reset',
                            className: 'btn-success'
                        },
                        cancel: {
                            label: 'No, cancel',
                            className: ''
                        }
                    },
                    inputType: 'textarea',
                    required: false,
                    callback: function (result) {
                        if (result !== null) {

                            axios
                                .post(target.dataset.url, {
                                    storeId: target.dataset.storeId,
                                    comments: result
                                })
                                .then(function (response) {
                                    window.location.reload();
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });

                        }
                    }
                });

            } else if (target.classList.contains('retailer-approval-reset')) {

                bootbox.prompt({
                    title: "Are you sure you'd like to reset <strong>" + target.parentElement.dataset.brandName + "'s</strong> approval with <strong>" + target.parentElement.dataset.retailerName + "</strong>?",
                    buttons: {
                        confirm: {
                            label: 'Yes, reset',
                            className: 'btn-success'
                        },
                        cancel: {
                            label: 'No, cancel',
                            className: ''
                        }
                    },
                    inputType: 'textarea',
                    required: false,
                    callback: function (result) {
                        if (result !== null) {

                            axios
                                .post(target.dataset.url, {
                                    retailerId: target.dataset.retailerId,
                                    comments: result
                                })
                                .then(function (response) {
                                    window.location.reload();
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });

                        }
                    }
                });

            }

            return false;

        } else if (target.tagName === 'A' && target.classList.contains('status-history')) {

            axios
                .get(target.dataset.url)
                .then(function (response) {

                    // console.log(response);

                    let statusText = '<table class="status-history"><thead><tr><td>Status</td><td>Status Text</td><td>Status At</td></tr></thead><tbody>';

                    response.data.statuses.forEach(status => {
                        statusText += '<tr><td>' + status.name + '</td><td>' + (status.text !== null ? status.text : 'N/A') + '</td><td>' + status.date + '</td></tr>';
                    });

                    statusText += '<tbody></table>'

                    bootbox.alert({
                        title: 'Status History',
                        message: statusText,
                    });

                })
                .catch(function (error) {
                    console.log(error);
                });

            return false;
        }
    };
}

export {attachApprovalHandlers as default};
